import { render } from "./DemandAddModal.vue?vue&type=template&id=1704dda2&scoped=true"
import script from "./DemandAddModal.vue?vue&type=script&lang=js"
export * from "./DemandAddModal.vue?vue&type=script&lang=js"

import "./DemandAddModal.vue?vue&type=style&index=0&id=1704dda2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1704dda2"]])

export default __exports__